export const getPaises = (state) => state.paises.lista
export const getPaisSelecionado = (state) => state.paises.selecionado
export const getIsCarregandoListaPaises = (state) => state.paises.isCarregandoLista
export const getIsUpdatingListaPaises = (state) => state.paises.isUpdate
